import * as stylex from '@stylexjs/stylex';
import type { ICellRendererParams } from 'ag-grid-community';
import type { CellRendererValueProps } from '../cellRenderer.types';

export type PlainTextProps = CellRendererValueProps<string | number> &
  Partial<Pick<ICellRendererParams<unknown, string | number, unknown>, 'valueFormatted'>> & {
    truncateText?: boolean;
  };

/** Vertically centers text, preferring the formatted value with optional ellipsis truncation. */
export const PlainText = ({ value, valueFormatted, truncateText = false }: PlainTextProps) => (
  <div {...stylex.props(styles.root)}>
    <span {...stylex.props(truncateText && styles.truncatedText)}>{valueFormatted ?? value}</span>
  </div>
);

const styles = stylex.create({
  root: { display: 'flex', height: '100%', alignItems: 'center' },
  truncatedText: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
});
